import React from 'react';
import { useTranslation } from 'react-i18next';
import Loader from './Loader.js';
import UpdateRequired from './UpdateRequired.js';
import { useAppVersionCheck } from '../../hooks/useAppVersionCheck.js';

const AppVersionGate = ({ children }) => {
  const { t } = useTranslation();
  const versionState = useAppVersionCheck();

  if (versionState.status === 'checking') {
    return <Loader message={t('appUpdate.checking')} />;
  }

  if (versionState.status === 'update_required') {
    return <UpdateRequired {...versionState} />;
  }

  return children;
};

export default AppVersionGate;
